import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';

@Component({
    selector: 'app-about-us-page',
    templateUrl: './about-us.component.html',
    styles: [],
    standalone: true,
    imports: [CarouselComponent, CommonModule]
})
export class AboutUsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
